module.exports = ".shipment-container {\n  border-top: 5px outset #26c6da;\n  border-radius: 5px;\n  background-color: #ffffff;\n  font-size: 12px;\n  margin-bottom: 25px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shipments/components/shipment-title/shipment-title.component.scss
// module id = ./src/app/modules/shipments/components/shipment-title/shipment-title.component.scss
// module chunks = main